import { render, staticRenderFns } from "./zixun.vue?vue&type=template&id=7d470130&scoped=true&"
import script from "./zixun.vue?vue&type=script&lang=js&"
export * from "./zixun.vue?vue&type=script&lang=js&"
import style0 from "./zixun.vue?vue&type=style&index=0&id=7d470130&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d470130",
  null
  
)

export default component.exports